import { db } from "../firebase/firebaseConfig";
import { collection, getDocs,  orderBy, query } from "firebase/firestore";

const usersService = {
  getAll:  async () => {
    const q    = query(collection(db, "users"), orderBy("createdAt", "desc"));
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ id: d.id, ...d.data() }));
  },
};

export default usersService;
